import { LoadingButton } from "@mui/lab";
import { Button, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";
import Modal from "components/modals/Modal";

type Props = {
  loading: boolean;
  header?: React.ReactNode;
  content: React.ReactNode;
  open?: boolean;
  submitBtnLabel: string;
  onSubmit: () => void;
  onClose: () => void;
}

const ActionModal: React.FC<Props> = ({ loading, header, content, open, onSubmit, onClose, submitBtnLabel }) => {
  const { t } = useTranslation('modal');

  const renderFooter = () => {
    return (
      <DialogActions>
        <LoadingButton loading={loading} onClick={onSubmit} data-testid="btn.submit">{submitBtnLabel}</LoadingButton>
        <Button onClick={onClose} data-testid="btn.close">{t('modal:btn.close')}</Button>
      </DialogActions>
    )
  }

  return <Modal
    header={header}
    content={content}
    footer={renderFooter()}
    open={open} />
}

export default ActionModal;